/******/ (function() { // webpackBootstrap
/**
 * Section: Cart page
 * ------------------------------------------------------------------------------
 * This re-directs the user from the cart page and back to the homepage.
 *
 */
if (window.location.pathname.includes('/cart')) {
  var localizedRoot = window.location.pathname.replace(/\/cart(\/.*)?$/, '/');
  if (localizedRoot.indexOf('/cart') !== -1) localizedRoot = '/';
  window.location.replace(localizedRoot + '?showCart=true');
}
/******/ })()
;